export const REDIRECT_TO_BUNDLE_CUSTOMISATION =
  "lpg-redirect-to-customisation-app";
